import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { Icon } from "@syarahtech/ui";
import { useTranslation } from "@i18n";
import FlowStepMeta from "@/pages/sell-my-car/components/FlowStepMeta";
import { useScreenNavigation } from "@/common/Contexts/ScreenNavigationContext";
import { SELL_CAR_SCREENS, useScreenMetadata } from "@/pages/sell-my-car/constants/screens";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import { twMerge } from "tailwind-merge";
import { useSellCarData } from "@/common/Contexts/SellCarDataContext";
import { useSearchParams } from "react-router-dom";
import { updateToPreviousStep } from "@/apis/sell-my-car";
import { useEffect, useState } from "react";
import useBoolean from "@hooks/useBoolean";
var FLowHeader = function FLowHeader(_ref) {
  var onCancel = _ref.onCancel;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useScreenNavigation = useScreenNavigation(),
    state = _useScreenNavigation.state,
    actions = _useScreenNavigation.actions;
  var screenMetadata = useScreenMetadata();
  var _useSellCarData = useSellCarData(),
    carDataState = _useSellCarData.state,
    dataActions = _useSellCarData.actions;
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var requestId = searchParams.get('request_id');
  var _useState = useState(false),
    isNavigatingBack = _useState[0],
    setIsNavigatingBack = _useState[1];
  var canGoBack = actions.canGoBack();
  var currentScreen = state.currentScreen;
  var screenMeta = screenMetadata[currentScreen];
  var backVisibility = useBoolean(true);
  useEffect(function () {
    if (currentScreen === SELL_CAR_SCREENS.CAR_MAKE) {
      backVisibility.setFalse();
      return;
    }
    if (requestId) {
      if (currentScreen === SELL_CAR_SCREENS.CONTACT_INFO) {
        backVisibility.setFalse();
        return;
      }
    }
    // Hide back button when OTP screen is visible on contact info screen
    if (currentScreen === SELL_CAR_SCREENS.CONTACT_INFO && carDataState !== null && carDataState !== void 0 && carDataState.isOtpVisible) {
      backVisibility.setFalse();
      return;
    }
    backVisibility.setTrue();
  }, [currentScreen, canGoBack, searchParams, requestId, carDataState === null || carDataState === void 0 ? void 0 : carDataState.isOtpVisible]);
  var handleBackClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _response$data, response, _stepData$current_ste, stepData, previousStepKey, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (!requestId) {
              _context.n = 8;
              break;
            }
            setIsNavigatingBack(true);
            _context.p = 1;
            _context.n = 2;
            return updateToPreviousStep({
              request_id: requestId
            });
          case 2:
            response = _context.v;
            if (!(response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.success)) {
              _context.n = 4;
              break;
            }
            _context.n = 3;
            return dataActions.fetchStepData();
          case 3:
            stepData = _context.v;
            previousStepKey = stepData === null || stepData === void 0 ? void 0 : (_stepData$current_ste = stepData.current_step) === null || _stepData$current_ste === void 0 ? void 0 : _stepData$current_ste.step_key;
            if (previousStepKey) {
              // Navigate to the previous step
              actions.navigateToScreen(previousStepKey);
            }
          case 4:
            _context.n = 6;
            break;
          case 5:
            _context.p = 5;
            _t = _context.v;
            console.error("Error navigating back:", _t);
          case 6:
            _context.p = 6;
            setIsNavigatingBack(false);
            return _context.f(6);
          case 7:
            _context.n = 9;
            break;
          case 8:
            if (canGoBack) {
              // Before contact info - use normal client-side navigation
              // make_id removal is handled by setOnNavigateBack callback in SellMyCarRoot
              actions.goBack();
            }
          case 9:
            return _context.a(2);
        }
      }, _callee, null, [[1, 5, 6, 7]]);
    }));
    return function handleBackClick() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleCancelClick = function handleCancelClick() {
    if (onCancel) {
      onCancel();
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-flow-header",
    className: "flex flex-col gap-4 md:bg-blue-alice md:min-h-[285px]"
  }, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-flow-header-nav",
    className: "px-4 pt-3 pb-4 flex items-center justify-between md:max-w-[2000px] md:w-[90%] md:mx-auto md:pt-6"
  }, /*#__PURE__*/React.createElement(Conditional, {
    condition: backVisibility.value
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-flow-back-button",
    onClick: handleBackClick,
    className: twMerge("cursor-pointer md:px-4 md:py-2 md:bg-white md:text-gray-text md:rounded md:border md:border-solid md:border-[#D6DFE9] md:min-w-[86px] md:leading-4 md:flex md:justify-center md:gap-1", canGoBack || requestId ? "cursor-pointer" : "opacity-0 pointer-events-none")
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--arrow-forward-ios-rounded",
    className: "text-black-primary md:text-primary-new en:rotate-180 en:transform",
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("span", {
    id: "sell-car-flow-back-text",
    className: "hidden md:inline  md:text-sm md:text-[#6C7A8D] en:capitalize"
  }, tShort("sell_trade_v2/back", {
    ns: "web_sell_trade"
  })))), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-flow-back-placeholder",
    className: "w-6 h-6"
  }))), /*#__PURE__*/React.createElement("div", {
    id: "sell-car-flow-cancel-button",
    role: "button",
    className: "text-sm text-black-primary font-medium leading-6 ms-auto cursor-pointer md:px-6 md:py-2 md:bg-white md:text-gray-text md:rounded md:border md:border-solid md:border-[#D6DFE9] md:min-w-[86px] md:leading-4 md:flex md:justify-center",
    onClick: handleCancelClick
  }, tShort("sell_trade_v2/cancel", {
    ns: "web_sell_trade"
  }))), /*#__PURE__*/React.createElement(FlowStepMeta, {
    title: (screenMeta === null || screenMeta === void 0 ? void 0 : screenMeta.title) || "",
    icon: (screenMeta === null || screenMeta === void 0 ? void 0 : screenMeta.icon) || "material-symbols--directions-car-rounded",
    progress: ((screenMeta === null || screenMeta === void 0 ? void 0 : screenMeta.step) || 1) / ((screenMeta === null || screenMeta === void 0 ? void 0 : screenMeta.totalSteps) || 1) * 100,
    breadcrumbs: state.navigationHistory
  })));
};
export default FLowHeader;